<template lang="pug">
GenericCard.pending-order-list(size='auto')
  .d-flex.align-items-center.justify-content-between.p-3
    .d-flex
      .text-large รายการรออนุมัติ
      LoadingIndicator.ml-2(v-if='isLoading')
    CustomDatePicker(v-model='filterDate')
  hr.m-0
  .pt-2.pb-2.px-3
    CustomTable(
      :columns='tableCols'
      :data='tableData'
      @itemClicked='tableItemClicked'
    )
  .sticky-bottom.bg-white
    hr.m-0
    .px-4.py-3
      CustomPagination(
        v-model='currentPage'
        :total='totalPage'
      )
</template>

<script>
/* eslint-disable arrow-body-style */
export default {
  computed: {
    filteredTableData() {
      return this.tableData.filter((item) => {
        return (this.filterDate === '') || (this.$dateUtils.isInRange(item.date, this.filterDate));
      });
    },
  },
  watch: {
    filterDate() {
      this.currentPage = 1;
      this.loadData();
    },
  },
  data: () => ({
    tableCols: {
      entryNo: {
        title: 'เลขที่รายการ',
        align: 'left',
        type: 'EntryNo',
      },
      // dueDate: {
      //   title: 'วันที่ครบกำหนด',
      //   align: 'center',
      //   type: Date,
      // },
      customerName: {
        title: 'ชื่อลูกค้า',
        align: 'left',
        computed(row) {
          if (row.customer) {
            return row.customer.name;
          }
          return '-';
        },
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        // computed(row) {
        //   if (row.products) {
        //     return row.products.reduce((total, prod) => (total + Number(prod.price)), 0);
        //   }
        //   return 0;
        // },
      },
      date: {
        title: 'วันที่ทำรายการ',
        align: 'center',
        type: Date,
      },
    },
    tableData: [],
    filterDate: '',
    isLoading: false,
    currentPage: 1,
    totalPage: 1,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // const res = await this.$api.cs.user.pendingOrderList();
      const res = await this.$api.cs.sellRecord.csApprovalList(this.currentPage, this.filterDate);
      if (res.status === 200) {
        this.tableData = res.data.data;
        this.currentPage = res.data.current_page;
        this.totalPage = res.data.last_page;
        this.$emit('finishLoading', res.data);
      }

      this.isLoading = false;
    },

    tableItemClicked(e) {
      // const { index, data } = e;
      this.$router.push({
        name: 'cs.sell-record', // can't use path, cause it WON'T allow passing hidden params
        params: {
          order: e.data,
          actionType: 'SELL_LIST',
          // ...e, // pass everything in, LOL
        },
      });
    },
  },
};
</script>

<style lang="scss">
// .pending-order-list {
//   height: --webkit-fill-available;
// }
.filter-date {
  font-size: 20px;
}
</style>
